var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftChevronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3691 14.2479L21.6221 3.99486L19.5008 1.87354L7.12644 14.2479L19.5008 26.6223L21.6221 24.501L11.3691 14.2479Z",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevronWhite);
export default __webpack_public_path__ + "static/media/leftChevronWhite.344d2a458234f5a75d260dfb6b83fafd.svg";
export { ForwardRef as ReactComponent };